<template>
<div class="content-class">
	<v-tabs v-model="active" color="black" dark slider-color="primary">
		<v-tab :key="'proUser'" ripple>Utilisateur</v-tab>
		<v-tab :key="'Logs'" ripple>Logs</v-tab>

		<v-tab-item :key="'proUser'">
			<pro-user-form v-model="document">
			</pro-user-form>

			<v-btn :disabled="loading" color="error" @click="deleteUser()">
				<v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
				Supprimer
			</v-btn>

		</v-tab-item>

		<v-tab-item :key="'Logs'">
			<log-list :url="'logs?filter=references.reference:$eq:proUsers;references.referenceId:$eq:'+$route.params.id">
			</log-list>
		</v-tab-item>
	</v-tabs>
</div>
</template>
<script>
import ProUserForm from '../../components/proUsers/proUser.form'
import LogList from '../../components/logs/log.list.vue'

import { ERROR, SUCCESS } from '../../variables'

export default {
	components: { ProUserForm, LogList },
	data() {
		return {
			loading: false,
			active: null,
			document: null
		}
	},
	methods: {
		deleteUser() {
			this.axios.delete('proUsers/' + this.$route.params.id)
				.then(response => {
					this.$router.push({ name: 'ProUserList' })
					this.$store.dispatch(SUCCESS, 'Utilisateur supprimé')
				})
				.catch((err) => {
					this.$store.dispatch(ERROR, err)
				})
		}
	},
	mounted() {
		this.axios
			.get('proUsers/' + this.$route.params.id)
			.then(response => {
				this.document = response.data
			})
			.catch((err) => {
				this.$store.dispatch(ERROR, err)
			})
	}

}
</script>
<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/proUsers/proUser.detail.vue